import React from 'react';
import { Accordion } from './Accordion';

/**
 * Subtle guarantee note shown right below the add-to-cart button.
 */
export function GuaranteeSection() {
  return <Accordion id="garantia" className="bg-transparent border-gold/15" openClassName="bg-gold/[0.04] !border-gold/30" headerClassName="py-3.5" header={<span className="block font-sans text-[14px] font-medium leading-snug text-ivory/70" data-id="element-55" data-mp="ercwjffbcjsp">
          🛡️ Nuestra Garantía "El primer Mate va por nuestra cuenta"
        </span>} data-id="element-54" data-mp="4x32zuemxfge">
      <p className="font-sans text-[14px] leading-relaxed text-ivory/60" data-id="element-56" data-mp="nsb3o6l1t7fi">
        Sabemos que comprar un libro digital puede generar dudas. Por eso,
        durante los próximos 7 días todo el riesgo corre por nuestra cuenta.
        Explorá el contenido, prepará tus primeros mates y descubrí si este
        método es para vos. Si no quedás completamente satisfecho, te devolvemos
        el 100% de tu dinero. Así de simple: solo enviános un correo al contacto
        de nuestra web.
      </p>
    </Accordion>;
}